/*
 * @Descripttion: 
 * @Author: zhaozheng
 * @Version: 0.0.1
 * @Date: 2025-11-18 19:58:41
 * @LastEditors: zhaozheng
 * @LastEditTime: 2025-11-21 23:54:51
 */
import React, { ReactNode, useEffect, useRef, useState, forwardRef } from 'react';
import { css, cx } from '@emotion/css';

const baseClass = css`
  opacity: 0;
  transition: opacity 0.6s ease;

  &.reveal-visible {
    opacity: 1;
  }
`;

type RevealProps = {
  children: ReactNode;
  direction?: number;
};

export const Reveal = forwardRef<HTMLDivElement, RevealProps>(({ children }, ref) => {
  const innerRef = useRef<HTMLDivElement | null>(null);
  const [visible, setVisible] = useState(false);

  // 合并refs的callback
  const setRefs = (node: HTMLDivElement | null) => {
    innerRef.current = node;

    if (typeof ref === 'function') {
      ref(node);
    } else if (ref) {
      (ref as React.MutableRefObject<HTMLDivElement | null>).current = node;
    }
  };

  useEffect(() => {
    const node = innerRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisible(entry.isIntersecting);
      },
      { threshold: 0.25 }
    );

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div
      ref={setRefs}
      className={cx(baseClass, { 'reveal-visible': visible })}
    >
      {children}
    </div>
  );
});

Reveal.displayName = 'Reveal';
